import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { PollResultRow } from './poll-result-rows'

// Horizontal bar chart. Percentages relate to the number of voters, so they
// also work for multiple-choice polls where one voter picks several options.
export function PollResults({ rows, voterCount }: { rows: PollResultRow[]; voterCount: number }) {
  if (rows.length === 0) {
    return <p className="text-sm text-muted-foreground">Noch keine Antwortmöglichkeiten.</p>
  }

  return (
    <div className="space-y-3">
      {rows.map((row) => {
        const percent = voterCount > 0 ? Math.round((row.votes / voterCount) * 100) : 0
        return (
          <div key={row.id} className="space-y-1">
            <div className="flex items-baseline justify-between gap-3 text-sm">
              <span className={cn('min-w-0 break-words', row.mine && 'font-medium')}>
                {row.label}
                {row.mine && (
                  <Badge variant="secondary" className="ml-2 align-middle">
                    Deine Wahl
                  </Badge>
                )}
              </span>
              <span className="shrink-0 tabular-nums text-muted-foreground">
                {row.votes === 1 ? '1 Stimme' : `${row.votes} Stimmen`} · {percent}%
              </span>
            </div>
            <div className="h-2 w-full rounded-full bg-muted">
              <div className="h-full rounded-full bg-primary" style={{ width: `${percent}%` }} />
            </div>
            {row.author && <p className="text-xs text-muted-foreground">Eingebracht von {row.author}</p>}
          </div>
        )
      })}
    </div>
  )
}
